export const hasGroup = (rolePermissionGroup, permissionGroupCode) => {
  if (Array.isArray(permissionGroupCode)) {
    for (let code of permissionGroupCode) {
      if (hasGroup(rolePermissionGroup, code)) return true
    }
  } else {
    for (let role in rolePermissionGroup) {
      if (rolePermissionGroup[role][permissionGroupCode]) return true
    }
  }
  return false
}

export const has = (rolePermissionGroup, permissionCode, authorityCode) => {
  if (Array.isArray(permissionCode)) {
    for (let code of permissionCode) {
      if (has(rolePermissionGroup, code, authorityCode)) return true
    }
  } else {
    for (let role in rolePermissionGroup) {
      for (let group in rolePermissionGroup[role]) {
        let permission = rolePermissionGroup[role][group][permissionCode]
        if (permission) {
          if (authorityCode === undefined) return true
          else if (permission === authorityCode) return true
        }
      }
    }
  }
  return false
}
